module.exports = __webpack_public_path__ + "static/img/6587_phase_function_Paper_PointsHejduk_Prediction.60869f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6587_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 2rS5
// module chunks = 0